(function(){

  // --- BUNDLE WIDGET LOGIC ---

  const ns='trwidget';

  const root=document.querySelector('.ai-bundle-'+ns);

  if(root) {

   const config = {
        currency: root.dataset.currency || 'USD',
        tier1: root.dataset.tier1Text || 'Starter',
        tier3: root.dataset.tier3Text || 'Free Patch',
        tier6: root.dataset.tier6Text || 'Free Shipping',
        code6: root.dataset.discountCode6 || '',
        cta: root.dataset.ctaText || 'Select at least 1 box'
      };

      // NEW: Check if every single item on the page is sold out
      const availableItems = root.querySelectorAll('.ai-bundle__item-trwidget:not(.is-sold-out)').length;
      if (availableItems === 0) {
         config.cta = "ALL ITEMS SOLD OUT"; // Overrides the default "Select at least 1 box" text
      }


      const qtyMap = new Map();

      let isSub = true; 



      const commonLabel = "https://cdn.shopify.com/s/files/1/0491/5645/6601/files/nutrition-panel.png?v=1770116426";

      const nutritionData = [

        { 

          name: "Strawberry Strike", 

          img: "https://cdn.shopify.com/s/files/1/0491/5645/6601/files/Strawberry_ee9d8999-65de-4f57-80d1-c3f61e0db5ad.png?v=1770114517", 

          label: commonLabel, 

          ingredients: "Tapioca Syrup, Allulose, Water, Organic Cane Sugar, Pectin, Strawberry Organic Flavor, Citric Acid, Malic Acid, White Rice Flour, Sodium Malate, Sodium Citrate, Monk Fruit Extract, Organic Fruit and Vegetable Juice for Color" 

        },

        { 

          name: "Green Apple Rattle", 

          img: "https://cdn.shopify.com/s/files/1/0491/5645/6601/files/Apple_6aa95aee-ed2a-40a9-9617-530f93e90976.png?v=1770114513", 

          label: commonLabel, 

          ingredients: "Tapioca Syrup, Allulose, Water, Organic Cane Sugar, Pectin, Apple and Peach Organic Flavor, Citric Acid, Malic Acid, White Rice Flour, Sodium Malate, Sodium Citrate, Monk Fruit Extract, Organic Fruit and Vegetable Juice for Color" 

        },

        { 

          name: "Breach Peach", 

          img: "https://cdn.shopify.com/s/files/1/0491/5645/6601/files/Peach_8864e169-899f-44c0-9d12-9eefe3a75d6f.png?v=1770114513", 

          label: commonLabel, 

          ingredients: "Tapioca Syrup, Allulose, Water, Organic Cane Sugar, Pectin, Peach Organic Flavor, Citric Acid, Malic Acid, White Rice Flour, Sodium Malate, Sodium Citrate, Monk Fruit Extract, Organic Fruit and Vegetable Juice for Color" 

        }

      ];



      const money = (c) => new Intl.NumberFormat('en-US', {

        style: 'currency', currency: config.currency 

      }).format((c||0)/100);



      const fill=root.querySelector('.ai-bundle__fill-'+ns);

      const ticks=root.querySelectorAll('.ai-bundle__tick-'+ns);

      const trackWrap = root.querySelector('.ai-bundle__trackwrap-'+ns);

      const cta=root.querySelector('.ai-bundle__cta-'+ns);

      const subOpts=root.querySelectorAll('.ai-bundle__sub-opt');

      const subOldEl = root.querySelector('[data-price-target="sub-old"]');

      const subNewEl = root.querySelector('[data-price-target="sub-new"]');

      const onetimeEl = root.querySelector('[data-price-target="onetime"]');

      const tierLabels = root.querySelectorAll('.ai-bundle__tier-price');



      // --- FREE SHIPPING MARKER ---

      let fsMarker = root.querySelector('.ai-bundle__fs-marker');

      if(!fsMarker && trackWrap) {

        fsMarker = document.createElement('div');

        fsMarker.className = 'ai-bundle__fs-marker';

        fsMarker.textContent = 'FREE SHIPPING';

        trackWrap.appendChild(fsMarker);

      }



      let defaultUnitPrice = 0;

      const firstProduct = root.querySelector('.ai-bundle__item-'+ns);

      if(firstProduct) {

         defaultUnitPrice = parseInt(firstProduct.getAttribute('data-price')) || 0;

      }



      function calculateTierPrice(qty, isSubscription) {

          let volMult = 1.0;

          if (qty >= 6) volMult = 0.76;      

          else if (qty >= 3) volMult = 0.86; 

          

          let price = defaultUnitPrice * volMult;

          

          if (isSubscription) {

              price = price * 0.85; 

          }

          return price;

      }



      function render(){

        let totalBase = 0; 

        let totalQty = 0;      

        

        root.querySelectorAll('.ai-bundle__item-'+ns).forEach(row=>{

          const vid=row.getAttribute('data-variant-id');

          const price=parseInt(row.getAttribute('data-price'))||0;

          let q = qtyMap.get(vid)||0;

          

          if(q > 0) {

            totalBase += price * q; 

            totalQty += q;

          }



          if(q > 0) {

            row.setAttribute('data-has-qty', 'true');

            row.querySelector('.ai-bundle__qtynum-'+ns).textContent = q;

          } else {

            row.setAttribute('data-has-qty', 'false');

          }

        });



        let volumeMultiplier = 1.0;

        if(totalQty >= 6) volumeMultiplier = 0.76;

        else if(totalQty >= 3) volumeMultiplier = 0.86;



        let baseAmountForCalc = (totalQty > 0) ? totalBase : defaultUnitPrice;

        let qtyForCalc = (totalQty > 0) ? totalQty : 1;



        let discountedOneTimeTotal = baseAmountForCalc * volumeMultiplier;

        let displayBasePrice = discountedOneTimeTotal / qtyForCalc;

        let discountedSubTotal = discountedOneTimeTotal * 0.85; 

        let displaySubPrice = discountedSubTotal / qtyForCalc;

        let finalTotal = isSub ? discountedSubTotal : discountedOneTimeTotal;

        let ctaStrikeTotal = baseAmountForCalc; 



        if(subOldEl) subOldEl.textContent = money(baseAmountForCalc / qtyForCalc);

        if(subNewEl) subNewEl.textContent = money(displaySubPrice) + "/ea";

        if(onetimeEl) onetimeEl.textContent = money(displayBasePrice) + "/ea";



        let activeTier = 0;

        if (totalQty >= 6) activeTier = 6;

        else if (totalQty >= 3) activeTier = 3;

        else if (totalQty >= 1) activeTier = 1;



        tierLabels.forEach(label => {

            const tier = parseInt(label.dataset.tier);

            const tierPrice = calculateTierPrice(tier, isSub);

            label.textContent = money(tierPrice) + "/ea";

            

            if (activeTier > 0 && tier === activeTier) label.classList.add('is-active');

            else label.classList.remove('is-active');

        });



        subOpts.forEach(opt => {

          opt.classList.toggle('is-selected', (opt.dataset.type === 'sub') === isSub);

        });



        let pct = 0;

        if(totalQty === 1) pct = 0; 

        else if(totalQty === 2) pct = 25; 

        else if(totalQty === 3) pct = 50; 

        else if(totalQty === 4) pct = 66; 

        else if(totalQty === 5) pct = 83; 

        else if(totalQty >= 6) pct = 100; 

        

        if(fill) fill.style.width = pct + '%';

        ticks[0].classList.toggle('is-active', totalQty >= 1);

        ticks[1].classList.toggle('is-active', totalQty >= 3);

        ticks[2].classList.toggle('is-active', totalQty >= 6);



        // --- FREE SHIPPING TOGGLE ---

        if(fsMarker) {

            if(finalTotal > 5500) {

                fsMarker.classList.add('is-active');

            } else {

                fsMarker.classList.remove('is-active');

            }

        }



        cta.disabled = (totalQty === 0);

        

        if(totalQty === 0) {

            cta.textContent = config.cta; 

        } else {

            let showStrike = isSub || totalQty >= 3;

            let priceHtml = showStrike ? `<span class="ai-bundle__price-old">${money(ctaStrikeTotal)}</span><span class="ai-bundle__price-new">${money(finalTotal)}</span>` : `<span class="ai-bundle__price-new">${money(finalTotal)}</span>`;

            

            cta.innerHTML = `Add to Cart <span class="ai-bundle__price-pill">${priceHtml}</span><div class="ai-bundle__cta-loader"></div>`;



            const shippingBadge = root.querySelector('.ai-bundle__shipping-badge');

            if(shippingBadge) shippingBadge.style.display = 'none'; 

        }

      }



      subOpts.forEach(opt => opt.addEventListener('click', () => { isSub = (opt.dataset.type === 'sub'); render(); }));



     root.querySelectorAll('.ai-bundle__item-'+ns).forEach(row=>{
        const addBtn = row.querySelector('.ai-bundle__add-'+ns);
        const decBtn = row.querySelector('.ai-bundle__stepbtn-'+ns+'[data-action="decrease"]');
        const incBtn = row.querySelector('.ai-bundle__stepbtn-'+ns+'[data-action="increase"]');

        // Only add the click events if the buttons actually exist in the HTML
        if (addBtn && !addBtn.disabled) {
          addBtn.addEventListener('click', (e)=>{ e.preventDefault(); qtyMap.set(row.getAttribute('data-variant-id'), 1); render(); });
        }
        if (decBtn) {
          decBtn.addEventListener('click', (e)=>{ e.preventDefault(); let q = qtyMap.get(row.getAttribute('data-variant-id'))||0; if(q>0) q--; qtyMap.set(row.getAttribute('data-variant-id'), q); render(); });
        }
        if (incBtn) {
          incBtn.addEventListener('click', (e)=>{ e.preventDefault(); let q = qtyMap.get(row.getAttribute('data-variant-id'))||0; qtyMap.set(row.getAttribute('data-variant-id'), q+1); render(); });
        }
      });


      cta.addEventListener('click', async ()=>{

        if(cta.disabled || cta.classList.contains('is-loading')) return;

        

        cta.classList.add('is-loading');



        const items=[]; 

        root.querySelectorAll('.ai-bundle__item-'+ns).forEach(row => {

          const q = qtyMap.get(row.getAttribute('data-variant-id')) || 0;

          if(q > 0) {

            const item = { id: row.getAttribute('data-variant-id'), quantity: q };

            if(isSub && row.getAttribute('data-selling-plan-id')) item.selling_plan = parseInt(row.getAttribute('data-selling-plan-id'));

            items.push(item);

          }

        });



        const res = await fetch('/cart/add.js',{ method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({ items }) });

        if(res.ok) window.location.href = (!isSub && (qtyMap.get('total')||0) >= 6) ? `/discount/${config.code6}?redirect=/cart` : '/cart';

      });



      function setupNutritionAccordion() {

        const accHead = document.querySelector('.nutrition-accordion-head');

        const accBody = document.querySelector('.nutrition-accordion-body');

        const selector = document.querySelector('.nutrition-selector');

        const dropdown = document.querySelector('.nutrition-dropdown');

        const labelImg = document.querySelector('.nutrition-label-img');

        const ingText = document.querySelector('.nutrition-ingredients');

        

        if(!accHead) return;

        nutritionData.forEach(item => {

          const opt = document.createElement('div');

          opt.className = 'nutrition-option';

          opt.innerHTML = `<img src="${item.img}" class="nutrition-thumb"><span class="nutrition-opt-name">${item.name}</span>`;

          opt.addEventListener('click', () => {

            selector.innerHTML = `Flavor: ${item.name} <svg style="width:12px; height:12px;" viewBox="0 0 24 24"><path fill="currentColor" d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"/></svg>`;

            labelImg.src = item.label;

            ingText.innerHTML = `<strong>Ingredients:</strong> ${item.ingredients}`;

            document.querySelector('.nutrition-display').style.display = 'block';

            dropdown.style.display = 'none';

          });

          dropdown.appendChild(opt);

        });

        accHead.addEventListener('click', () => { accBody.style.display = accBody.style.display === 'block' ? 'none' : 'block'; });

        selector.addEventListener('click', (e) => { e.stopPropagation(); dropdown.style.display = dropdown.style.display === 'block' ? 'none' : 'block'; });

      }



      setupNutritionAccordion();

      render();

  }



  // --- FAQ ACCORDION LOGIC ---

  const faqItems = document.querySelectorAll('.javvy-faq-item');

  if(faqItems.length) {

    faqItems.forEach(item => {

      const head = item.querySelector('.javvy-faq-head');

      head.addEventListener('click', () => {

        const isOpen = item.classList.contains('is-open');

        // Close others

        faqItems.forEach(other => { if(other !== item) other.classList.remove('is-open'); });

        // Toggle current

        item.classList.toggle('is-open', !isOpen);

      });

    });

  }

// Ensure the steps video autoplays immediately

const stepsVideo = document.querySelector('.javvy-steps-video');

if (stepsVideo) {

  stepsVideo.play().catch(error => {

    console.log("Autoplay was prevented, but muted attribute is set.");

  });

}

  // --- VIDEO GRID PLAY LOGIC (WITH SOUND) ---

  const videoWrappers = document.querySelectorAll('.javvy-video-wrapper');

  if(videoWrappers.length) {

    videoWrappers.forEach(wrapper => {

      const video = wrapper.querySelector('video');

      wrapper.addEventListener('click', () => {

        if (video.paused) {

          // Pause others and reset

          videoWrappers.forEach(w => {

             const v = w.querySelector('video');

             if(v !== video) { v.pause(); w.classList.remove('is-playing'); }

          });

          // Unmute explicitly on interaction to allow sound

          video.muted = false;

          video.play();

          wrapper.classList.add('is-playing');

        } else {

          video.pause();

          wrapper.classList.remove('is-playing');

        }

      });

      video.addEventListener('ended', () => { wrapper.classList.remove('is-playing'); });

    });

  }



})();

document.addEventListener("DOMContentLoaded", function() {
  
  // 1. Select Elements
  // We added '.ai-bundle__summary-trwidget' to make absolutely sure it targets the main button, not the sticky one!
  const originalBtn = document.querySelector('.ai-bundle__summary-trwidget .ai-bundle__cta-trwidget'); 
  const stickyBar = document.getElementById('javvy-sticky-atc');
  const stickyBtn = document.getElementById('sticky-proxy-btn');
  const section1 = document.querySelector('.javvy-section-1');
  const footer = document.querySelector('.javvy-footer-container');

  if (!originalBtn || !stickyBar || !stickyBtn || !section1) return;


  // 2. PROXY LOGIC: Sync Sticky Button with Original Button
  function syncButtonState() {
    // Copy inner HTML (Text, Price pills, Loaders)
    stickyBtn.innerHTML = originalBtn.innerHTML;
    // Copy Disabled State
    stickyBtn.disabled = originalBtn.disabled;
    // Copy Classes (to maintain loading states)
    stickyBtn.className = `ai-bundle__cta-trwidget sticky-btn-override ${originalBtn.classList.contains('is-loading') ? 'is-loading' : ''}`;
  }

  // Initial Sync
  syncButtonState();

  // Watch for changes on the original button (Price updates, Loading states)
  const observer = new MutationObserver(syncButtonState);
  observer.observe(originalBtn, { attributes: true, childList: true, subtree: true });

  // When Sticky Button is clicked, click the original button
  stickyBtn.addEventListener('click', (e) => {
    e.preventDefault();
    originalBtn.click();
  });

  // 3. SCROLL LOGIC
  function handleScroll() {
    // Only run on mobile
    if (window.innerWidth > 768) return;

    const scrollY = window.scrollY;
    const windowH = window.innerHeight;
    
    // Calculate Triggers
    const section1Top = section1.offsetTop;
    const footerTop = footer.offsetTop;
    const triggerPoint = section1Top - 100; // Start slightly before sec 1 text for smooth entry
    const endPoint = footerTop - windowH; // When footer enters view

    // Logic:
    // 1. Must be past Section 1 start
    // 2. Must be BEFORE the footer
    if (scrollY > triggerPoint && scrollY < endPoint) {
      stickyBar.classList.add('is-visible');
    } else {
      stickyBar.classList.remove('is-visible');
    }
  }

  // Optimize Scroll Event with RequestAnimationFrame
  let ticking = false;
  window.addEventListener('scroll', function() {
    if (!ticking) {
      window.requestAnimationFrame(function() {
        handleScroll();
        ticking = false;
      });
      ticking = true;
    }
  });

  // Run once on load to check position
  handleScroll();
});